import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Row, Col } from 'antd';
import { Animated } from "react-animated-css";


import AdPackageCard from '../../components/advertisement/adpackagecard';



import './Advertisement.css';

import {
	
	
	advertisementGetPackage,
	advertisementGetOrder

} from '../../modules/advertisement';


class Advertisement extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loadingactiveusers: false,
			loadingOrder: false,
		}
	}

	async componentDidMount() {
		const { advertisementPackageList, advertisementOrderList} = this.props;	
		
		if (!advertisementPackageList){
			this.getAdvertisementPackageList();
		}
		if (!advertisementOrderList){
			this.props.advertisementGetOrder();
		}

	}

	async componentDidUpdate(prevProps) {
		const {  advertisementPackageList, advertisementOrderList } = this.props;
		
		if(!advertisementPackageList && JSON.stringify(advertisementPackageList) !== JSON.stringify(prevProps.advertisementPackageList)){
			this.getAdvertisementPackageList();
		}
		if(!advertisementOrderList && JSON.stringify(advertisementOrderList) !== JSON.stringify(prevProps.advertisementOrderList)){
			this.setState({ loadingOrder: true });
			await this.props.advertisementGetOrder();
			this.setState({ loadingOrder: false });
		}
	}

	
	
	getAdvertisementPackageList = async () => {
		this.setState({ loadingactiveusers: true });
		await this.props.advertisementGetPackage();
		this.setState({ loadingactiveusers: false });
	}

	render() {
		const { loadingactiveusers, loadingOrder } = this.state;

		return (
			<Animated animationIn="fadeIn">
				<div className="mainContentWrapper" style={{ paddingBottom: (this.props.play) ? '100px' : '20px' }}>
					<Row>
						<Col span={24}>
							<AdPackageCard loading={loadingactiveusers} loadingOrder={loadingOrder}/>
						</Col>
						
					</Row>
				</div>
			</Animated>
		);
	}


}

const mapStateToProps = state => ({
	router: state.router,
	userProfile: state.user.userProfile,
	selectedOrganization: state.user.selectedOrganization,
	inspectionTime: state.analytics.inspectionTime,
	advertisementPackageList: state.advertisement.advertisementPackageList,
	advertisementOrderList: state.advertisement.advertisementOrderList
	
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			
			advertisementGetPackage,
			advertisementGetOrder
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(Advertisement);
